module.exports = __webpack_public_path__ + "static/media/not-found.082b8c63.svg";